<template>
    <div class="cargo-transportation">
        <div class="cargo-transportation__text">
            <h2 class="section-title">Виды грузоперевозок Беларусь — Россия</h2>
            <p class="cargo-transportation__subtitle">ПЭК оказывает услуги авто — и авиаперевозок из Беларуси в Россию;
                из России в Беларусь — автотранспортом.
                Грузоперевозки возможны как LTL (в составе сборного груза), так и FTL (выделенным транспортом).
                ПЭК работает c физическими и юридическими лицами, также готовы предложить перевозки грузов от
                физлиц в адрес юрлиц и наоборот.
            </p>
        </div>
        <div class="cargo-transportation__list">
            <div class="cargo-transportation__list-column">
                <div class="cargo-transportation__list-item">
                    <img class="cargo-transportation__list-img"
                            src="@/assets/images/global-blue.svg"
                            alt="Иконка земной шар">
                    <div class="cargo-transportation__list-text">
                        <h3 class="cargo-transportation__list-title">Автомобильные перевозки по Беларуси и в Россию</h3>
                        <p class="cargo-transportation__list-subtitle">Что мы предлагаем</p>
                        <ul class="cargo-transportation__list-ul">
                            <li class="cargo-transportation__list-subtitle">Перевозка сборных и генеральных грузов</li>
                            <li class="cargo-transportation__list-subtitle">Выбор оптимального вида транспорта</li>
                            <li class="cargo-transportation__list-subtitle">Работа c физлицами и юрлицами</li>
                        </ul>
                    </div>
                </div>
                <div class="cargo-transportation__list-item">
                    <img class="cargo-transportation__list-img"
                            src="@/assets/images/element-4.svg"
                            alt="Иконка плитка">
                    <div class="cargo-transportation__list-text">
                        <h3 class="cargo-transportation__list-title">LTL: сборные грузы</h3>
                        <p class="cargo-transportation__list-subtitle">Сборные грузы — грузы разных отправителей:</p>
                        <ul class="cargo-transportation__list-ul">
                            <li class="cargo-transportation__list-subtitle">
                                Имеющие различные весогабаритные и прочие характеристики
                            </li>
                            <li class="cargo-transportation__list-subtitle">Консолидированные в общую партию</li>
                            <li class="cargo-transportation__list-subtitle">Которые едут в транспортном средстве вместе</li>
                        </ul>
                        <p class="cargo-transportation__list-subtitle">
                            Это оптимальный вариант для любого количества грузов,
                            когда не нужна целая машина</p>
                    </div>
                </div>
            </div>
            <div class="cargo-transportation__list-column">
                <div class="cargo-transportation__list-item">
                    <img class="cargo-transportation__list-img" src="@/assets/images/truck.svg" alt="Иконка грузовика">
                    <div class="cargo-transportation__list-text">
                        <h3 class="cargo-transportation__list-title">FTL — полные фуры: оптимально для бизнеса</h3>
                        <p class="cargo-transportation__list-subtitle">
                            Генеральные грузы предполагают полную фуру,
                            отдельную машину для клиента и персональный маршрут</p>
                    </div>
                </div>
                <div class="cargo-transportation__list-item">
                    <img class="cargo-transportation__list-img" src="@/assets/images/flash.svg" alt="Иконка молния">
                    <div class="cargo-transportation__list-text">
                        <h3 class="cargo-transportation__list-title">Экспресс-доставка и срочные перевозки</h3>
                        <p class="cargo-transportation__list-subtitle">
                            Это услуга по быстрой перевозке грузов, где приоритетом являются минимальные сроки транспортировки.
                            Для экспресс перевозок выделяется отдельный транспорт чтобы осуществлять перевозку в приоритете/быстрее
                        </p>
                    </div>
                </div>
                <div class="cargo-transportation__list-item">
                    <img class="cargo-transportation__list-img" src="@/assets/images/box.svg" alt="Иконка коробки">
                    <div class="cargo-transportation__list-text">
                        <h3 class="cargo-transportation__list-title">Перевозка негабаритных грузов</h3>
                        <p class="cargo-transportation__list-subtitle">Перевозку негабаритных грузов делаем по запросу клиента</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.cargo-transportation {
    margin-top: 80px;
    display: flex;
    flex-direction: column;
    gap: 40px;
}

.section-title {
    font-weight: 600;
    font-style: SemiBold;
    font-size: 36px;
    leading-trim: NONE;
    line-height: 46px;
    letter-spacing: 0%;
    margin: 0;
}

.cargo-transportation__text {
    display: flex;
    flex-direction: column;
    gap: 24px;
}
.cargo-transportation__subtitle {
    font-weight: 400;
    font-style: Regular;
    font-size: 18px;
    leading-trim: NONE;
    line-height: 26px;
    letter-spacing: 0%;
    margin: 0;
}
.cargo-transportation__list {
    display: flex;
    justify-content: space-between;
    gap: 20px;
}
.cargo-transportation__list-column {
    flex: 0 0 calc(50%-10px);
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.cargo-transportation__list-item {
    height: 100%;
    padding: 24px;
    display: flex;
    gap: 20px;
    border-radius: 20px;
    background-color: #F5F5F5;
    max-width: 630px;
}
.cargo-transportation__list-img {
    width: 60px;
    height: 60px;
    padding: 12px;
    border-radius: 8px;
    background-color: #48538B1A;
}
.cargo-transportation__list-text {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 0;
}
.cargo-transportation__list-title {
    font-weight: 500;
    font-style: Medium;
    font-size: 20px;
    leading-trim: NONE;
    line-height: 28px;
    letter-spacing: 0%;
    vertical-align: middle;
    margin: 0;
}
.cargo-transportation__list-subtitle {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0%;
    color: #757575;
    margin: 0;
}
.cargo-transportation__list-ul {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 16px;
    list-style-type: square;
    margin-left: 14px;
}
.section-title {
    font-weight: 600;
    font-style: SemiBold;
    font-size: 36px;
    leading-trim: NONE;
    line-height: 46px;
    letter-spacing: 0%;
    margin: 0;
}
@media screen and (max-width: 1279px) {
    .section-title {
        font-size: 24px;
        line-height: 32px;
    }
    .cargo-transportation__list {
        flex-direction: column;
        gap: 16px;
    }
    .cargo-transportation__list-column {
        gap: 16px;
    }
    .cargo-transportation__list-item {
        flex-direction: column;
        gap: 16px;
        max-width: none;
    }
    .cargo-transportation__list-img {
        width: 36px;
        height: 36px;
        padding: 6px;
    }
}
@media screen and (max-width: 768px) {
    .section-title {
        font-size: 22px;
        line-height: 28px;
    }
    .cargo-transportation__subtitle {
        font-size: 16px;
        line-height: 24px;
    }
    .cargo-transportation__list-item {
        padding: 16px;
    }
    .cargo-transportation__list-title {
        font-size: 18px;
        line-height: 26px;
    }
    .cargo-transportation {
        margin-top: 40px;
    }
}


</style>